export default function (constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
export function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);

  for (var key in definition) prototype[key] = definition[key];

  return prototype;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-color@1.4.1@d3-color/src/define.js
// module id = 46
// module chunks = 0